/* eslint-disable no-underscore-dangle */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router-dom';
import {
  Container, Grid, Segment, Card, Table, Button, List, Message,
  Popup, FormInput, Label, Icon, Dropdown,
} from 'semantic-ui-react';

import { base, REGEX_PATTERNS } from '../../../config/constants';
import { getUserDisplayNameFromEmail } from '../../../helpers/format';
import { AlertBox, ConfirmBox, SelectBox, askConfirmation, setAlertMsg } from '../../../components/Modals/index';

export default class EditTheme extends Component {
  static propTypes = {
    history: PropTypes.object,
    habilitations: PropTypes.object,
    themeId: PropTypes.string,
    deletedThemeId: PropTypes.func,
    bringStateUp: PropTypes.func,
    themeType: PropTypes.string,
  }

  static defaultProps = {
    habilitations: { uid: null },
    // match: { params: {} },
    history: null,
    themeId: null,
    deletedThemeId: () => null,
    bringStateUp: () => null,
    themeType: 'themes',
  }

  constructor(props) {
    super(props);
    this.state = {
      selectedThemeLoading: true,
      selectedTheme: null,
      selectedThemeId: null,
      adminsLoading: true,
      possibleGroups: [],
      admins: [],
      editing: {
        nom: false,
        groupe: false,
        contactEmail: false,
        mdp: false,
      },
      saving: {
        nom: false,
        groupe: false,
        contactEmail: false,
        isProtected: false,
        isHidden: false,
        mdp: false,
      },
    };
  }

  componentDidMount() {
    this._ismounted = true;
    // console.log('did mount ', this.props);
    if (this.props.themeId) {
      this.selectedBinding = base.bindToState(`${this.props.themeType}/${this.props.themeId}`, {
        context: this,
        state: 'selectedTheme',
        then: () => this.setState({ selectedThemeLoading: false, selectedThemeId: this.props.themeId }),
      });
    }
    base.bindToState('administrateurs', {
      context: this,
      state: 'admins',
      asArray: true,
      queries: {
        orderByChild: 'email',
      },
      then: () => this.setState({ adminsLoading: false }),
    });
    base.bindToState('themeGroupes', {
      context: this,
      state: 'possibleGroups',
      asArray: true,
      // then: () => this.setState({ adminsLoading: false }),
    });
  }

  componentWillReceiveProps(nextProps) {
    console.log(nextProps.themeId);
    if (nextProps.themeId !== this.props.themeId) {
      this.setState({ selectedThemeLoading: true });
      base.removeBinding(this.selectedBinding);
      if (nextProps.themeId) {
        this.selectedBinding = base.bindToState(`${this.props.themeType}/${this.props.themeId}`, {
          context: this,
          state: 'selectedTheme',
          asArray: true,
          queries: {
            orderByKey: true,
          },
          then: () => this.setState({ selectedThemeLoading: false, selectedThemeId: this.props.themeId }),
        });
      } else {
        this.setState({ selectedThemeLoading: false, selectedThemeId: null, selectedTheme: null });
      }
    }
  }

  getFilteredAdmins = () => {
    if (this.state.admins.length === 0 || !this.state.selectedThemeId) {
      return [];
    }
    return _.filter(
      this.state.admins,
      a => a.habilitations && a.habilitations[this.props.themeType]
        && a.habilitations[this.props.themeType][this.state.selectedThemeId],
    );
  }

  getThemeTypeLabel = (cap = false, plural = false) => {
    switch (this.props.themeType) {
      case 'themes':
        return `${(cap ? 'P' : 'p')}rofession${(plural ? 's' : '')}`;
      case 'citizenly':
        return `${(cap ? 'C' : 'c')}ommune${(plural ? 's' : '')}`;
      case 'elected':
        return `${(cap ? 'C' : 'c')}irconscription${(plural ? 's' : '')}`;
      default:
        return '[THEME]';
    }
  }

  handleEdit = (property) => {
    this.setState({
      editing: {
        ...this.state.editing,
        [property]: true,
      },
    });
    this.inputFields[property] = this.state.selectedTheme[property];
  }

  handleDeleteTheme = themeId => this.setState(askConfirmation(
    `Supprimer la ${this.getThemeTypeLabel()} ?`,
    `Vous allez <strong>supprimer la ${this.getThemeTypeLabel()} ${themeId.toUpperCase()}</strong>, cette opération est irréversible.<br/><br/>Voulez-vous vraiment supprimer cette ${this.getThemeTypeLabel()} ?`,
    'destructive',
    () => {
      base.remove(`${this.props.themeType}/${themeId}`).then(() => {
        this.props.bringStateUp(setAlertMsg(
          null,
          `${this.getThemeTypeLabel(true)} supprimée`,
          `Cette ${this.getThemeTypeLabel()} a bien été supprimée`,
          'success',
        ));
        this.props.deletedThemeId();
      }).catch((error) => {
        this.setState(setAlertMsg(
          error.code || null,
          `Impossible de supprimer cette ${this.getThemeTypeLabel()}`,
          error.toString(),
          'error',
        ));
      });
    },
    'OUI, SUPPRIMER',
  ))

  handleSave = (property, themeId) => {
    if (property === 'nom' && !this.inputFields[property]) {
      return this.setState({
        editing: {
          ...this.state.editing,
          [property]: false,
        },
        saving: {
          ...this.state.saving,
          [property]: false,
        },
      });
    }

    if (property === 'groupe' && !this.inputFields[property]) {
      return this.setState({
        editing: {
          ...this.state.editing,
          [property]: false,
        },
        saving: {
          ...this.state.saving,
          [property]: false,
        },
      });
    }

    if (
      property === 'contactEmail'
      && this.inputFields[property]
      && !REGEX_PATTERNS.email.test(this.inputFields[property])
    ) {
      return this.setState({
        editing: {
          ...this.state.editing,
          [property]: false,
        },
        saving: {
          ...this.state.saving,
          [property]: false,
        },
      });
    }

    this.setState({
      saving: {
        ...this.state.saving,
        [property]: true,
      },
    });
    // console.log(property, this.inputFields[property])

    return base.update(`${this.props.themeType}/${themeId}`, { data: { [property]: this.inputFields[property] || null } }).then(() => {
      this.setState({
        editing: {
          ...this.state.editing,
          [property]: false,
        },
        saving: {
          ...this.state.saving,
          [property]: false,
        },
      });
    }).catch((error) => {
      this.inputFields[property] = null;
      this.setState({
        ...setAlertMsg(error.code || null, 'Impossible de modifier ce thème', error.toString(), 'error'),
        editing: {
          ...this.state.editing,
          [property]: false,
        },
      });
    });
  }

  handleToggleProtected = (themeId, trueIfMakePublic) => {
    this.setState(askConfirmation(
      trueIfMakePublic ? 'Désactiver la protection par mot de passe' : 'Activer la protection par mot de passe',
      trueIfMakePublic
        ? `Tout le monde pourra consulter les messages envoyés à cette ${this.getThemeTypeLabel()}.
        <br/><br/>Voulez-vous vraiment <strong>désactiver la protection par mot de passe</strong> ?`
        : `Seuls les utilisateurs abonnés ou connaissant le mot de passe pourront lire les messages envoyés à cette ${this.getThemeTypeLabel()}.
        <br/><br/>Voulez-vous vraiment <strong>activer la protection par mot de passe</strong> ?`,
      trueIfMakePublic ? 'warn' : 'neutral',
      () => {
        base.update(`${this.props.themeType}/${themeId}`, { data: { protect: !trueIfMakePublic } }).catch((error) => {
          this.setState(setAlertMsg(error.code || null, 'Impossible de modifier ce thème', error.toString(), 'error'));
        });
      },
      trueIfMakePublic ? 'OUI, RENDRE PUBLIC' : 'OUI, ACTIVER LA PROTECTION',
    ));
  }

  handleToggleVisible = (themeId, trueIfMakeVisible) => {
    this.setState(askConfirmation(
      trueIfMakeVisible ? 'Rendre visible à tous' : 'Limiter la visibilité',
      trueIfMakeVisible
        ? `Cette ${this.getThemeTypeLabel()} apparaîtra dans la liste des ${this.getThemeTypeLabel(false, true)} sélectionnables pour tous les utilisateurs de l'application mobile.
        <br/><br/>Voulez-vous vraiment <strong>rendre cette ${this.getThemeTypeLabel()} visible par tous les utilisateurs</strong> ?`
        : `Cette ${this.getThemeTypeLabel()} n'apparaîtra plus dans la liste des ${this.getThemeTypeLabel(false, true)} sélectionnables, sauf pour les utilisateurs ayant déjà accès à cette ${this.getThemeTypeLabel()}.
        <br/><br/>Voulez-vous vraiment <strong>rendre cette ${this.getThemeTypeLabel()} uniquement visible par les ayant déjà accès à cette ${this.getThemeTypeLabel()}</strong> ?`,
      trueIfMakeVisible ? 'warn' : 'neutral',
      () => {
        base.update(`${this.props.themeType}/${themeId}`, { data: { visible: trueIfMakeVisible } }).catch((error) => {
          this.setState(setAlertMsg(error.code || null, 'Impossible de modifier ce thème', error.toString(), 'error'));
        });
      },
      trueIfMakeVisible ? 'OUI, RENDRE VISIBLE' : 'OUI, LIMITER LA VISIBILITÉ',
    ));
  }

  inputFields = {
    nom: null,
    contactEmail: null,
    groupe: null,
    mdp: null,
  };
  selectedBinding;

  render() {
    console.log(this.state);
    const noneSelected = this.state.selectedTheme === null;
    const filteredAdmins = this.getFilteredAdmins();
    return (
      <Container>
        <Segment basic loading={this.state.recipientsLoading}>
          <Grid columns={1}>
            <Grid.Column width={16}>
              <Grid.Row>
                <Segment basic loading={this.state.selectedThemeLoading || this.state.adminsLoading}>
                  <Card fluid raised={!noneSelected}>
                    <Card.Content>
                      <Card.Header
                        content={
                          !noneSelected ?
                            `PROFESSION: ${this.state.selectedThemeId}`.toUpperCase() : 'Aucun thème sélectionné'
                        }
                      />
                    </Card.Content>
                    <Card.Content>
                      <Table definition={!noneSelected} color={!noneSelected ? 'blue' : null}>
                        <Table.Body>
                          <Table.Row disabled={noneSelected}>
                            <Table.Cell collapsing>Identifiant</Table.Cell>
                            <Table.Cell textAlign="center">
                              {this.state.selectedThemeId}
                            </Table.Cell>
                            <Table.Cell collapsing>
                              <Popup
                                trigger={
                                  <Button
                                    icon="help"
                                    basic
                                    circular
                                    disabled={noneSelected}
                                  />
                                }
                              >
                                <Popup.Content>
                                  Cette information n'est pas modifiable
                                </Popup.Content>
                              </Popup>
                            </Table.Cell>
                          </Table.Row>
                          <Table.Row disabled={noneSelected}>
                            <Table.Cell collapsing>Nom&nbsp;d'affichage</Table.Cell>
                            <Table.Cell textAlign="center">
                              {!this.state.editing.nom && !noneSelected ? this.state.selectedTheme.nom : (
                                <FormInput
                                  fluid
                                  defaultValue={!noneSelected ? this.state.selectedTheme.nom : ''}
                                  autoFocus
                                  minLength={3}
                                  loading={this.state.saving.nom}
                                  onChange={(e) => {
                                    this.inputFields.nom = e.target.value;
                                  }}
                                  placeholder="Nom public"
                                />
                              )}
                            </Table.Cell>
                            <Table.Cell collapsing>
                              {this.props.habilitations.superuser ? (
                                <Popup
                                  trigger={
                                    <Button
                                      icon={this.state.editing.nom ? 'save' : 'write'}
                                      color="green"
                                      inverted
                                      loading={this.state.saving.nom}
                                      disabled={noneSelected}
                                      onClick={
                                        () => noneSelected
                                          || (this.state.editing.nom
                                            ? this.handleSave('nom', this.state.selectedThemeId)
                                            : this.handleEdit('nom'))
                                      }
                                    />
                                  }
                                >
                                  <Popup.Content>
                                    {this.state.editing.nom ? 'Enregistrer' : `Renommer la ${this.getThemeTypeLabel()}`}
                                  </Popup.Content>
                                </Popup>
                              ) : (
                                <Popup
                                  trigger={
                                    <Button
                                      icon="help"
                                      basic
                                      circular
                                      disabled={noneSelected}
                                    />
                                  }
                                >
                                  <Popup.Content>
                                    Cette information n'est pas modifiable
                                  </Popup.Content>
                                </Popup>
                              )
                              }

                            </Table.Cell>
                          </Table.Row>
                          <Table.Row disabled={noneSelected}>
                            <Table.Cell>Adresse&nbsp;de&nbsp;contact</Table.Cell>
                            <Table.Cell textAlign="center">
                              {(!this.state.editing.contactEmail && !noneSelected)
                                ? this.state.selectedTheme.contactEmail : (
                                  <FormInput
                                    fluid
                                    defaultValue={!noneSelected ? this.inputFields.contactEmail : ''}
                                    autoFocus
                                    loading={this.state.saving.contactEmail}
                                    onChange={(e) => {
                                      this.inputFields.contactEmail = e.target.value.toLowerCase();
                                    }}
                                    placeholder="Adresse de contact"
                                    type="email"
                                  />
                                )}
                            </Table.Cell>
                            <Table.Cell collapsing>
                              <Popup
                                trigger={
                                  <Button
                                    icon={this.state.editing.contactEmail ? 'save' : 'write'}
                                    color="green"
                                    inverted
                                    loading={this.state.saving.contactEmail}
                                    disabled={noneSelected}
                                    onClick={
                                      () => noneSelected
                                        || (this.state.editing.contactEmail
                                          ? this.handleSave('contactEmail', this.state.selectedThemeId)
                                          : this.handleEdit('contactEmail'))
                                    }
                                  />
                                }
                              >
                                <Popup.Content>
                                  {this.state.editing.contactEmail ? 'Enregistrer' : 'Changer l\'adresse email'}
                                </Popup.Content>
                              </Popup>
                            </Table.Cell>
                          </Table.Row>
                          {this.props.themeType === 'themes' && (
                            <Table.Row>
                              <Table.Cell collapsing>Protection par mot de passe</Table.Cell>
                              <Table.Cell textAlign="center">
                                {!noneSelected && this.state.selectedTheme.protect
                                  ? (<Label color="green"><Icon name="lock" />ACTIVÉE - PROFESSION PROTÉGÉE</Label>)
                                  : (<Label color="red"><Icon name="unlock" />DÉSACTIVÉE - PROFESSION PUBLIQUE</Label>)}
                              </Table.Cell>
                              <Table.Cell collapsing>
                                {this.props.habilitations.superuser ? (
                                  <Button
                                    content={
                                      !noneSelected && this.state.selectedTheme.protect ? 'Désactiver' : 'Activer'
                                    }
                                    onClick={
                                      () => this.handleToggleProtected(
                                        this.state.selectedThemeId,
                                        this.state.selectedTheme.protect,
                                      )
                                    }
                                  />
                                ) : (
                                  <Popup
                                    trigger={
                                      <Button
                                        icon="help"
                                        basic
                                        circular
                                        disabled={noneSelected}
                                      />
                                    }
                                  >
                                    <Popup.Content>
                                      Cette information n'est pas modifiable
                                    </Popup.Content>
                                  </Popup>
                                )
                                }
                              </Table.Cell>
                            </Table.Row>
                          )}
                          {this.props.themeType === 'themes' && (
                            <Table.Row disabled={noneSelected}>
                              <Table.Cell collapsing>Mot de passe</Table.Cell>
                              <Table.Cell textAlign="center">
                                {!this.state.editing.mdp && !noneSelected ? this.state.selectedTheme.mdp : (
                                  <FormInput
                                    fluid
                                    defaultValue={!noneSelected ? this.state.selectedTheme.mdp : ''}
                                    autoFocus
                                    minLength={3}
                                    loading={this.state.saving.mdp}
                                    onChange={(e) => {
                                      this.inputFields.mdp = e.target.value;
                                    }}
                                    placeholder="Nom public"
                                  />
                                )}
                              </Table.Cell>
                              <Table.Cell collapsing>
                                {this.props.habilitations.superuser ? (
                                  <Popup
                                    trigger={
                                      <Button
                                        icon={this.state.editing.mdp ? 'save' : 'write'}
                                        color="green"
                                        inverted
                                        loading={this.state.saving.mdp}
                                        disabled={noneSelected}
                                        onClick={
                                          () => noneSelected
                                            || (this.state.editing.mdp
                                              ? this.handleSave('mdp', this.state.selectedThemeId)
                                              : this.handleEdit('mdp'))
                                        }
                                      />
                                    }
                                  >
                                    <Popup.Content>
                                      {this.state.editing.mdp ? 'Enregistrer' : 'Changer le mot de passe'}
                                    </Popup.Content>
                                  </Popup>
                                ) : (
                                  <Popup
                                    trigger={
                                      <Button
                                        icon="help"
                                        basic
                                        circular
                                        disabled={noneSelected}
                                      />
                                    }
                                  >
                                    <Popup.Content>
                                      Cette information n'est pas modifiable
                                    </Popup.Content>
                                  </Popup>
                                )
                                }

                              </Table.Cell>
                            </Table.Row>
                          )}
                          {this.props.themeType === 'themes' && (
                            <Table.Row>
                              <Table.Cell collapsing>Visibilité</Table.Cell>
                              <Table.Cell textAlign="center">
                                {!noneSelected && this.state.selectedTheme.visible
                                  ? (<Label color="grey"><Icon name="globe" />TOTALE - PROFESSION VISIBLE</Label>)
                                  : (<Label color="blue"><Icon name="eye" />RÉDUITE - PROFESSION MASQUÉE</Label>)
                                }
                              </Table.Cell>
                              <Table.Cell collapsing>
                                {this.props.habilitations.superuser ? (
                                  <Button
                                    content={
                                      !noneSelected && this.state.selectedTheme.visible
                                        ? 'Rendre invisible' : 'Rendre visible'
                                    }
                                    onClick={
                                      () => this.handleToggleVisible(
                                        this.state.selectedThemeId,
                                        !this.state.selectedTheme.visible,
                                      )
                                    }
                                  />
                                ) : (
                                  <Popup
                                    trigger={
                                      <Button
                                        icon="help"
                                        basic
                                        circular
                                        disabled={noneSelected}
                                      />
                                    }
                                  >
                                    <Popup.Content>
                                      Cette information n'est pas modifiable
                                    </Popup.Content>
                                  </Popup>
                                )
                                }
                              </Table.Cell>
                            </Table.Row>
                          )}
                          {this.props.themeType === 'themes' && (
                            <Table.Row>
                              <Table.Cell collapsing>Groupe</Table.Cell>
                              <Table.Cell textAlign="center">
                                {(!this.state.editing.groupe && !noneSelected)
                                  ? this.state.selectedTheme.groupe : (
                                    <Dropdown
                                      search
                                      selection
                                      selectOnBlur={false}
                                      selectOnNavigation={false}
                                      options={_.map(this.state.possibleGroups, (e, k) => ({
                                          key: k,
                                          value: e,
                                          text: e,
                                        }))}
                                        // direction="left"
                                      defaultValue={!noneSelected ? this.inputFields.groupe : ''}
                                      onChange={(e, { value }) => {
                                          this.inputFields.groupe = value;
                                          // console.log(value, this.inputFields.groupe)
                                        }}
                                    />
                                  )}
                              </Table.Cell>
                              <Table.Cell collapsing>
                                <Popup
                                  trigger={
                                    <Button
                                      icon={this.state.editing.groupe ? 'save' : 'write'}
                                      color="green"
                                      inverted
                                      loading={this.state.saving.groupe}
                                      disabled={noneSelected}
                                      onClick={
                                        () => noneSelected
                                          || (this.state.editing.groupe
                                            ? this.handleSave('groupe', this.state.selectedThemeId)
                                            : this.handleEdit('groupe'))
                                      }
                                    />
                                  }
                                >
                                  <Popup.Content>
                                    {this.state.editing.groupe ? 'Enregistrer' : 'Changer le groupe'}
                                  </Popup.Content>
                                </Popup>
                              </Table.Cell>
                            </Table.Row>
                          )}
                        </Table.Body>
                      </Table>
                    </Card.Content>

                    {filteredAdmins.length > 0 ?
                      (
                        <Card.Content>
                          <Card.Header textAlign="center">Administrateurs de la {this.getThemeTypeLabel()}</Card.Header>
                          <Container text>
                            <Segment basic>
                              <List celled selection={this.props.habilitations.superuser}>
                                {_.map(this.getFilteredAdmins(), a => (
                                  <List.Item
                                    key={a.key}
                                    onClick={() => !this.props.habilitations.superuser || this.props.history.push(`/access-mgt/view/${a.key}`)}
                                  >
                                    {this.props.habilitations.superuser ? (
                                      <List.Content floated="right">
                                        <Button
                                          icon="edit"
                                          // content="Gérer les habilitations"
                                        />
                                      </List.Content>
                                    ) : null}
                                    <List.Content>
                                      <List.Header>
                                        {getUserDisplayNameFromEmail(a.email)}
                                      </List.Header>
                                      {a.email}
                                    </List.Content>
                                  </List.Item>
                                ))}
                              </List>
                            </Segment>
                          </Container>
                        </Card.Content>
                      ) : (
                        <Card.Content>
                          <Card.Header textAlign="center">Administrateurs de la {this.getThemeTypeLabel()}</Card.Header>
                          <Message icon info>
                            <Icon name="info circle" />
                            <Message.Content>
                              <Message.Header>
                                Aucun administrateur défini pour cette {this.getThemeTypeLabel()}
                              </Message.Header>
                              Rendez-vous dans la <Link to="/access-mgt">Gestion des Administrateurs</Link> pour en
                              ajouter un.
                            </Message.Content>
                          </Message>
                        </Card.Content>
                      )
                    }
                    {filteredAdmins.length === 0 && this.props.habilitations.superuser
                    && (
                      <Card.Content>
                        <Segment basic textAlign="center">
                          <Button
                            content={`Supprimer cette ${this.getThemeTypeLabel()}`}
                            icon="remove"
                            color="red"
                            inverted
                            onClick={() => this.handleDeleteTheme(this.state.selectedThemeId)}
                            disabled={noneSelected}
                          />
                        </Segment>
                      </Card.Content>
                    )}
                    {filteredAdmins.length !== 0 && this.props.habilitations.superuser
                    && (
                      <Card.Content>
                        <Message icon info>
                          <Icon name="info circle" />
                          <Message.Content>
                            <Message.Header>Cette {this.getThemeTypeLabel()} ne peut pas être supprimée</Message.Header>
                            Une {this.getThemeTypeLabel()} ne peut être supprimée que si aucun administrateur n'est
                            habilité à celle-ci.
                          </Message.Content>
                        </Message>
                      </Card.Content>
                    )}
                  </Card>
                </Segment>
              </Grid.Row>
            </Grid.Column>
          </Grid>
        </Segment>
        <AlertBox
          propagateClosure={() => this.setState({ alert: { open: false } })}
          {...this.state.alert}
        />
        <ConfirmBox
          propagateClosure={() => this.setState({ confirm: { open: false } })}
          {...this.state.confirm}
        />
        <SelectBox
          propagateClosure={() => this.setState({ pick: { open: false } })}
          {...this.state.pick}
        />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/protected/_common/EditTheme.js